import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import UrlLink from '../url-link';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(0, 0, 2, 0)
  },
  name: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  meta: {
    marginLeft: theme.spacing(3.5),
  },
  mainIcon: {
    marginRight: theme.spacing(0.5),
  },
}));

const EventLocationOnline = ({ event, className, ...rest }) => {
  const classes = useStyles();

  const { infoUrl } = event;

  if (!infoUrl) {
    return null;
  }

  return (
    <div className={clsx(classes.wrapper, className)} {...rest}>
      <div className={classes.name}>
        <LocationOnIcon className={classes.mainIcon} />
        Online Event
      </div>
      <div className={classes.meta}>
        <UrlLink url={infoUrl} />
      </div>
    </div>
  );
};

EventLocationOnline.propTypes = {
  event: PropTypes.object,
  className: PropTypes.string,
};

export default EventLocationOnline;
